/* tslint:disable */
/* eslint-disable */
/**
 * BackOffice — Attributions par plateforme
 * Briques d\'un collaborateur par plateforme (override du compte, sémantique d\'override total avec repli sur le compte) et plafond délégable de la plateforme. Keyé par COLLABORATEUR (abpUserId) : un cabinet de N collaborateurs expose N lignes, et les collaborateurs d\'une corporate (sans ligne Courtier) sont adressables. Surface admin de l\'atelier des rôles + surface gouvernance du Portail Plateforme. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BriqueAttribuableDto } from './BriqueAttribuableDto';
import {
    BriqueAttribuableDtoFromJSON,
    BriqueAttribuableDtoFromJSONTyped,
    BriqueAttribuableDtoToJSON,
    BriqueAttribuableDtoToJSONTyped,
} from './BriqueAttribuableDto';

/**
 * 
 * @export
 * @interface GetBriquesCollaborateurPlateformeResponse
 */
export interface GetBriquesCollaborateurPlateformeResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBriquesCollaborateurPlateformeResponse
     */
    briquesCompte: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBriquesCollaborateurPlateformeResponse
     */
    briquesPlateforme?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBriquesCollaborateurPlateformeResponse
     */
    briquesAutorisees: Array<string>;
    /**
     * 
     * @type {Array<BriqueAttribuableDto>}
     * @memberof GetBriquesCollaborateurPlateformeResponse
     */
    briquesAutoriseesDetails?: Array<BriqueAttribuableDto>;
    /**
     * 
     * @type {string}
     * @memberof GetBriquesCollaborateurPlateformeResponse
     */
    nature?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBriquesCollaborateurPlateformeResponse
     */
    natureLibelle?: string | null;
}

/**
 * Check if a given object implements the GetBriquesCollaborateurPlateformeResponse interface.
 */
export function instanceOfGetBriquesCollaborateurPlateformeResponse(value: object): value is GetBriquesCollaborateurPlateformeResponse {
    if (!('briquesCompte' in value) || value['briquesCompte'] === undefined) return false;
    if (!('briquesAutorisees' in value) || value['briquesAutorisees'] === undefined) return false;
    return true;
}

export function GetBriquesCollaborateurPlateformeResponseFromJSON(json: any): GetBriquesCollaborateurPlateformeResponse {
    return GetBriquesCollaborateurPlateformeResponseFromJSONTyped(json, false);
}

export function GetBriquesCollaborateurPlateformeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBriquesCollaborateurPlateformeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'briquesCompte': json['briquesCompte'],
        'briquesPlateforme': json['briquesPlateforme'] == null ? undefined : json['briquesPlateforme'],
        'briquesAutorisees': json['briquesAutorisees'],
        'briquesAutoriseesDetails': json['briquesAutoriseesDetails'] == null ? undefined : ((json['briquesAutoriseesDetails'] as Array<any>).map(BriqueAttribuableDtoFromJSON)),
        'nature': json['nature'] == null ? undefined : json['nature'],
        'natureLibelle': json['natureLibelle'] == null ? undefined : json['natureLibelle'],
    };
}

export function GetBriquesCollaborateurPlateformeResponseToJSON(json: any): GetBriquesCollaborateurPlateformeResponse {
    return GetBriquesCollaborateurPlateformeResponseToJSONTyped(json, false);
}

export function GetBriquesCollaborateurPlateformeResponseToJSONTyped(value?: GetBriquesCollaborateurPlateformeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'briquesCompte': value['briquesCompte'],
        'briquesPlateforme': value['briquesPlateforme'],
        'briquesAutorisees': value['briquesAutorisees'],
        'briquesAutoriseesDetails': value['briquesAutoriseesDetails'] == null ? undefined : ((value['briquesAutoriseesDetails'] as Array<any>).map(BriqueAttribuableDtoToJSON)),
        'nature': value['nature'],
        'natureLibelle': value['natureLibelle'],
    };
}

